import { createSlice } from "@reduxjs/toolkit";

const Dashboardsclice = createSlice({
  name: "dashboard",
  initialState: {
    TotalRevenueLoading: false,
    TotalRevenue: null,
    TotalRevenueError: null,

    TotalActiveProductsLoading: false,
    TotalActiveProducts: null,
    TotalActiveProductsError: null,

    getRecentOrdersLoading: false,
    getRecentOrders: null,
    getRecentOrdersError: null,

    getlowStockProductsLoading: false,
    getlowStockProducts: null,
    getlowStockProductsError: null, 
  },
  reducers: {
    TotalRevenueRequest: (state) => {
      state.TotalRevenueLoading = true;
      state.TotalRevenueError = null;
    },
    TotalRevenueSuccess: (state, action) => {
      state.TotalRevenueLoading = false;
      state.TotalRevenue = action.payload;
    },
    TotalRevenueFailure: (state, action) => {
      state.TotalRevenueLoading = false;
      state.TotalRevenueError = action.payload;
    },
    TotalActiveProductsRequest: (state) => {
      state.TotalActiveProductsLoading = true;
      state.TotalActiveProductsError = null;
    },
    TotalActiveProductsSuccess: (state, action) => {
      state.TotalActiveProductsLoading = false;
      state.TotalActiveProducts = action.payload;
    },
    TotalActiveProductsFailure: (state, action) => {
      state.TotalActiveProductsLoading = false;
      state.TotalActiveProductsError = action.payload;
    },
    getRecentOrdersRequest: (state) => {
      state.getRecentOrdersLoading = true;
      state.getRecentOrdersError = null;
    },
    getRecentOrdersSuccess: (state, action) => {
      state.getRecentOrdersLoading = false;
      state.getRecentOrders = action.payload;
    },
    getRecentOrdersFailure: (state, action) => {
      state.getRecentOrdersLoading = false;
      state.getRecentOrdersError = action.payload;
    },
    getlowStockProductsRequest: (state) => {
      state.getlowStockProductsLoading = true;
      state.getlowStockProductsError = null;
    },
    getlowStockProductsSuccess: (state, action) => {
      state.getlowStockProductsLoading = false;
      state.getlowStockProducts = action.payload;
    },
    getlowStockProductsFailure: (state, action) => {
      state.getlowStockProductsLoading = false;
      state.getlowStockProductsError = action.payload;
    },  
  },
});

export const {
  TotalRevenueRequest,
  TotalRevenueSuccess,
  TotalRevenueFailure,
  TotalActiveProductsRequest,
  TotalActiveProductsSuccess,
  TotalActiveProductsFailure,
  getRecentOrdersRequest,
  getRecentOrdersSuccess,
  getRecentOrdersFailure, 
  getlowStockProductsRequest,
  getlowStockProductsSuccess,
  getlowStockProductsFailure, 
} = Dashboardsclice.actions;

export default Dashboardsclice.reducer;
